<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="700" [baseZIndex]="10000"
              header="Buscador UNLOCODE" (onShow)="showDialogMaximized(dialDetail)"
              (onHide)="cancelDialog()" #dialDetail>

        <div class="animated fadeIn">

            <div class="row">
                <div class="col-md-12">

                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Filtros
                                <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">

                            <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                            <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="CodPais">País</label>
                                        <ng-select [items]="listPais"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="CodPais"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listPais)"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('CodPais')"
                                                   clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>

                                        </ng-select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="Descripcion">Localización</label>
                                        <input formControlName="Descripcion" name="Descripcion" title="" class="form-control" id="Descripcion" type="text" value="">
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 8px;">
                                    <div class="col-md-12">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                            </div>

                                            <div class="btn-group">
                                                <button class="btn btn-secondary btn-sm" [disabled]="formIsUntouched" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!--GRID DATOS-->
            <div *ngIf="searchingButton" class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success">
                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Resultado de la búsqueda
                        </div>
                        <div class="card-body">
                            <p-table #tableSearch autoLayout="true" [value]="resultUnlocodes?.ResultList" [columns]="cols"
                                     selectionMode="single" sortField="Descripcion"
                                     [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                     [rows]="resultUnlocodes?.PageSize" [totalRecords]="resultUnlocodes?.TotalCount" [loading]="loading"
                                     [ngClass]="displayGridHidden(resultUnlocodes.ResultList)"
                                     styleClass="table table-responsive-sm table-striped table-sm">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                    <tr [pSelectableRow]="rowData" (click)="onSelect($event, rowData)" (dblclick)="onRowDblClick($event, rowData)">
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='Favorito'">
                                                {{rowData[col.field]}}
                                            </span>
                                            <span *ngIf="col.field==='Favorito'">
                                                {{rowData[col.field] | siNo}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div *ngIf="tableSearch.totalRecords" class="p-2">Se han encontrado {{tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                            <div class="empty-grid" *ngIf="tableSearch.totalRecords===0">No se ha encontrado ningún registro</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-footer>
            <button pButton (click)="acceptDialog()" [disabled]="noAccepted" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times"></button>
        </p-footer>

    </p-dialog>
</form>
